export default __webpack_public_path__ + "static/media/2_0098.81e07f53.webp";